"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_ui_1 = require("@sport-thieme/react-ui");
var Graph_1 = __importStar(require("../Graph"));
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
var maintenanceModeQuery_1 = __importDefault(require("../graphql/maintenanceModeQuery"));
var MaintenanceMode_1 = __importDefault(require("./MaintenanceMode"));
util_localization_1.default.addTranslations('de', {
    'The app is currently under maintenance mode': 'Diese App ist aktuell im Wartungsmodus',
    'Maintenance mode is scheduled for $0': 'Die App wird am $0 in den Wartungsmodus versetzt',
    dismiss: 'Schließen',
});
function MaintenanceModeProvider(_a) {
    var children = _a.children;
    return (react_1.default.createElement(Graph_1.default, null,
        react_1.default.createElement(MaintenanceInnerComponent, null, children)));
}
exports.default = MaintenanceModeProvider;
function MaintenanceInnerComponent(_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(undefined), maintenanceMessage = _b[0], setMaintenanceMessage = _b[1];
    var _c = (0, react_1.useState)(undefined), snackbarMessage = _c[0], setSnackBarMessage = _c[1];
    var slug = location.hostname.split('.').shift();
    var snackbarTitleNoWrap = (0, react_ui_1.useMediaQuery)('(min-width: 500px)');
    var _d = (0, Graph_1.useQuery)(maintenanceModeQuery_1.default, {
        pollInterval: 60000,
        variables: { slug: slug },
        fetchPolicy: 'no-cache',
    }), data = _d.data, stopPolling = _d.stopPolling;
    var app = (0, react_1.useMemo)(function () {
        return (data === null || data === void 0 ? void 0 : data.app) || {
            maintenanceModeActivated: false,
        };
    }, [data]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if ((data === null || data === void 0 ? void 0 : data.app) === null) {
            stopPolling();
        }
        if (app) {
            localStorage.setItem(LocalStorageKey.data, JSON.stringify(app));
        }
        var localAppData = fetchLocalData();
        var now = Date.now();
        var infoDate = (_a = app.maintenanceInfoDate) !== null && _a !== void 0 ? _a : localAppData === null || localAppData === void 0 ? void 0 : localAppData.maintenanceInfoDate;
        var startDate = (_b = app.maintenanceStartDate) !== null && _b !== void 0 ? _b : localAppData === null || localAppData === void 0 ? void 0 : localAppData.maintenanceStartDate;
        var isActivated = (_d = (_c = app.maintenanceModeActivated) !== null && _c !== void 0 ? _c : localAppData === null || localAppData === void 0 ? void 0 : localAppData.maintenanceModeActivated) !== null && _d !== void 0 ? _d : false;
        var message = (_f = (_e = app.maintenanceMessage) !== null && _e !== void 0 ? _e : localAppData === null || localAppData === void 0 ? void 0 : localAppData.maintenanceMessage) !== null && _f !== void 0 ? _f : (0, util_localization_1.localize)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["The app is currently under maintenance mode"], ["The app is currently under maintenance mode"])));
        var notificationMessage = (_g = app.maintenanceNotificationMessage) !== null && _g !== void 0 ? _g : localAppData === null || localAppData === void 0 ? void 0 : localAppData.maintenanceNotificationMessage;
        setMaintenanceMessage(undefined);
        setSnackBarMessage(undefined);
        if (infoDate === null ||
            infoDate === undefined ||
            startDate === null ||
            startDate === undefined)
            return;
        var userDismissed = localStorage.getItem(LocalStorageKey.dismiss);
        var adminDismissed = localStorage.getItem(LocalStorageKey.adminDismiss);
        if (userDismissed !== startDate) {
            localStorage.removeItem(LocalStorageKey.dismiss);
        }
        if (adminDismissed !== startDate) {
            localStorage.removeItem(LocalStorageKey.adminDismiss);
        }
        if (localStorage.getItem(LocalStorageKey.adminDismiss) !== null) {
            return;
        }
        var timeouts = [];
        if (localStorage.getItem(LocalStorageKey.dismiss) === null &&
            ((now < Date.parse(startDate) && isActivated) || isActivated === false)) {
            var infoTimeout = setTimeout(function () {
                setSnackBarMessage(react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_ui_1.P, { noWrap: snackbarTitleNoWrap },
                        react_1.default.createElement("strong", null, (0, util_localization_1.localize)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Maintenance mode is scheduled for ", ""], ["Maintenance mode is scheduled for ", ""])), new Date(startDate)
                            .toLocaleString()
                            .replace(':00:00', ':00')))),
                    notificationMessage && react_1.default.createElement(react_ui_1.P, null, notificationMessage)));
            }, Date.parse(infoDate) - now);
            timeouts.push(infoTimeout);
        }
        if (isActivated) {
            var maintenanceTimeout = setTimeout(function () {
                setSnackBarMessage(undefined);
                setMaintenanceMessage(message);
            }, Date.parse(startDate) - now);
            timeouts.push(maintenanceTimeout);
        }
        return function () {
            for (var _i = 0, timeouts_1 = timeouts; _i < timeouts_1.length; _i++) {
                var timeout = timeouts_1[_i];
                clearTimeout(timeout);
            }
        };
    }, [data]);
    var handleOnClose = function () {
        var _a, _b;
        var localData = fetchLocalData();
        localStorage.setItem(LocalStorageKey.dismiss, (_b = (_a = app.maintenanceStartDate) !== null && _a !== void 0 ? _a : localData === null || localData === void 0 ? void 0 : localData.maintenanceStartDate) !== null && _b !== void 0 ? _b : '');
        setSnackBarMessage(undefined);
    };
    var handleAdminDismiss = function () {
        var _a;
        localStorage.setItem(LocalStorageKey.adminDismiss, (_a = app.maintenanceStartDate) !== null && _a !== void 0 ? _a : '');
        setSnackBarMessage(undefined);
        setMaintenanceMessage(undefined);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_ui_1.SimpleSnackbar, { warning: snackbarMessage, onClose: handleOnClose, disableWindowBlurListener: true, autoHideDuration: null, anchorOrigin: { horizontal: 'center', vertical: 'bottom' } }),
        children,
        react_1.default.createElement(react_ui_1.Backdrop, { open: Boolean(maintenanceMessage), unmountOnExit: true, blur: true, style: { zIndex: 10000000 } },
            react_1.default.createElement(MaintenanceMode_1.default, { message: maintenanceMessage !== null && maintenanceMessage !== void 0 ? maintenanceMessage : '', onDismiss: handleAdminDismiss }))));
}
var fetchLocalData = function () {
    var localDataString = localStorage.getItem(LocalStorageKey.data);
    var localData = localDataString
        ? JSON.parse(localDataString)
        : undefined;
    return localData;
};
var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["data"] = "maintenanceMode";
    LocalStorageKey["dismiss"] = "maintenanceModeNotificationDismiss";
    LocalStorageKey["adminDismiss"] = "maintenanceModeAdminDismiss";
})(LocalStorageKey || (LocalStorageKey = {}));
var templateObject_1, templateObject_2;
//# sourceMappingURL=MaintenanceModeProvider.js.map